import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as stepperStyles from './Stepper.styles';
import { QuoteBuilderStep } from '../../utils/formState';
import { authenticated$ } from '../../../../store/session/selectors';

export interface StepperProps {
  currentStep: QuoteBuilderStep;
}

interface FormStepItem {
  value: number;
  quoteStep?: QuoteBuilderStep;
  title: string;
  percent: number;
}

const formStepList = (authenticated: boolean): Array<FormStepItem> => [
  {
    value: 2,
    quoteStep: QuoteBuilderStep.DETAILS,
    title: 'Order details',
    percent: authenticated ? 33.33 : 20,
  },
  {
    value: 3,
    quoteStep: QuoteBuilderStep.MIX,
    title: 'Site details',
    percent: authenticated ? 66.66 : 40,
  },
  {
    value: 4,
    quoteStep: QuoteBuilderStep.REGISTER,
    title: 'Date and time',
    percent: 60,
  },
  {
    value: 5,
    quoteStep: QuoteBuilderStep.MOBILE,
    title: 'Billing',
    percent: 80,
  },
];

function Stepper({ currentStep }: StepperProps) {
  const authenticated = useSelector(authenticated$);
  const stepList = useMemo(() => formStepList(authenticated), [authenticated]);

  const current = stepList.find((step) => step.quoteStep === currentStep);
  const { classes } = stepperStyles.useStepperStyles();
  if (!current) return null;

  return (
    <div className={classes.stepperContainer}>
      <div className={classes.stepperBar} style={{ width: `${current.percent}%` }} />
    </div>
  );
}

export default Stepper;
